import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
    fallbackLng: 'en',
    backend: {
        loadPath: '/wp-admin/admin-ajax.php?action=get_translations&component={{ns}}',
        parse: function (data) { return JSON.parse(data).translations; },
    },
    defaultNS: 'event',
    ns: ['event'],
});
export default i18n;
